import api from './axios';

class AuthService {
    // Logowanie
    async login(email, password) {
        try {
            const response = await api.post('/users/login', { email, password });
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
            }
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Błąd logowania';
        }
    }

    // Rejestracja
    async register(userData) {
        try {
            const response = await api.post('/users/register', userData);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Błąd rejestracji';
        }
    }

    // Weryfikacja 2FA
    async verify2FA(email, code) {
        try {
            const response = await api.post('/users/verify-2fa', { email, code });
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
            }
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Błąd weryfikacji 2FA';
        }
    }

    // Wysyłanie kodu 2FA
    async send2FACode(phone) {
        try {
            const response = await api.post('/users/send-2fa', { phone });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Błąd wysyłania kodu 2FA';
        }
    }

    // Reset hasła - wysłanie maila
    async requestPasswordReset(email) {
        try {
            const response = await api.post('/users/request-reset-password', { email });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Błąd wysyłania resetu hasła';
        }
    }

    // Reset hasła - ustawienie nowego hasła
    async resetPassword(token, password) {
        try {
            const response = await api.post('/users/reset-password', { token, password });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Błąd resetowania hasła';
        }
    }

    // Wylogowanie
    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }

    // Pobranie aktualnego użytkownika
    getCurrentUser() {
        const userStr = localStorage.getItem('user');
        if (userStr) return JSON.parse(userStr);
        return null;
    }

    // Pobranie tokena
    getToken() {
        return localStorage.getItem('token');
    }

    // Sprawdzenie czy użytkownik jest zalogowany
    isAuthenticated() {
        return !!this.getToken();
    }
}

// Eksportujemy pojedynczą instancję serwisu
export default new AuthService();